import { CuiButton } from 'front-lib'

interface Props {
  onSuccess: () => void
}

export const SuccessStep = ({ onSuccess }: Props) => {
  return (
    <div className="modal__content mobile-left">
      <div className="success-step">
        <h2 className="modal__title center small">
          🎉 You’ve successfully joined Weekly Box Ordering!
        </h2>

        <div className="modal__text">
          Welcome to Box Ordering — your new, flexible way to choose meals.
          Start building your box by adding meals to your cart.
        </div>
        <div className="modal__text">
          If it's not the right fit for your lifestyle, you can always return to
          the standard subscription from <strong>My Plan</strong>.
        </div>
      </div>

      <div className="modal__buttons small column">
        <CuiButton className="full" onClick={() => onSuccess()}>
          Start browsing the menu
        </CuiButton>
      </div>
    </div>
  )
}
